import React from 'react';

const Options = (props) => {
  // --- CORRECTION ---
  // On récupère les questions et le rôle depuis l'état global du chatbot
  const { questionsForRole, userRole } = props.state;
  if (!questionsForRole) {
    return null;
  }
  // On prend les 5 premières questions pour les suggestions initiales
  const suggestions = questionsForRole.slice(0, 5);
  // --- FIN DE LA CORRECTION ---

  const handleOptionClick = (questionText) => {
    props.actionProvider.handleUserMessage(questionText, userRole);
  };

  const options = suggestions.map((option) => (
    <button
      className="bg-gray-200 text-gray-800 py-2 px-4 rounded-lg m-1 text-sm hover:bg-gray-300"
      key={option.id}
      onClick={() => handleOptionClick(option.question)}
    >
      {option.question}
    </button>
  ));

  return <div className="flex flex-wrap">{options}</div>;
};

export default Options;